import React, {useContext} from 'react';
import {Container, Col, Spinner, Table} from 'react-bootstrap';
import { AppContext } from '../App';

export const HomePage=()=>{
	const { quickReport, getQuickLoad} = useContext(AppContext);
	return (
		<Container className="py-3">
			<Col  xs={12} sm={12} md={12} lg={12} className='bdr2 br-3 mb-3' >
				<Col xs="12" sm="12" md="12" lg="12" className="staff-type-header bgs1 d-grid p-2 bdrb2" >
					<span>{getQuickLoad?(<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>):'Quick Report.'}</span>
				</Col>
			</Col>
			<Col>
				{
					quickReport!==undefined?(
						Object.keys(quickReport).length>0?(
			        		<Table bordered className="tbl-bg-blue" >
						      <thead>
						        <tr>
						          <th><span className="tp2" >Username</span></th>
						          <th colspan={2} ><span className="tp2" >Staffs</span></th>
						          <th colspan={2} ><span className="tp2" >Tokens</span></th>
						          <th colspan={2} ><span className="tp2" >Bills</span></th>
						          <th colspan={2} ><span className="tp2" >OTP</span></th>
						        </tr>
						      </thead>
						      <tbody>
						      <tr>
						      	<td><span className="tp2" ></span></td>
		        				<td><span className="tp2" >Total</span></td>
		        				<td><span className="tp2" >Today</span></td>
		        				<td><span className="tp2" >Total</span></td>
		        				<td><span className="tp2" >Today</span></td>
		        				<td><span className="tp2" >Total</span></td>
		        				<td><span className="tp2" >Today</span></td>
		        				<td><span className="tp2" >Total</span></td>
		        				<td><span className="tp2" >Today</span></td>
						      </tr>
						      {
						      	Object.keys(quickReport).map((qitem,qli_i)=>(
			        			<tr key={`q_item_${qli_i}`} >
			        				<td><span className="tp2" >{quickReport[qitem].username}</span></td>
			        				<td><span className="tp2" >{quickReport[qitem].staff_accounts}</span></td>
			        				<td><span className="tp2" >{quickReport[qitem].today_staff_accounts}</span></td>
			        				<td><span className="tp2" >{quickReport[qitem].token_count}</span></td>
			        				<td><span className="tp2" >{quickReport[qitem].today_token_count}</span></td>
			        				<td><span className="tp2" >{quickReport[qitem].bill_count}</span></td>
			        				<td><span className="tp2" >{quickReport[qitem].today_bill_count}</span></td>
			        				<td><span className="tp2" >{quickReport[qitem].otp_count}</span></td>
			        				<td><span className="tp2" >{quickReport[qitem].today_otp_count}</span></td>					        				
			        			</tr>
				        		))
						      }
						      </tbody>
						    </Table>
			        		
			        	):''
					):'Fetching data...'
					        	
				}
			</Col>
		</Container>
		)
}